module.exports = __webpack_public_path__ + "static/media/old_bg.32924df2.png";